var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerBulletins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dealer_bulletins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_list-ul-solid",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    id: "list-ul-solid",
    d: "M17.742,51.462A1.731,1.731,0,1,0,16,49.731,1.736,1.736,0,0,0,17.742,51.462Zm4.645-2.885a1.154,1.154,0,1,0,0,2.308H32.839a1.154,1.154,0,1,0,0-2.308Zm0,5.769a1.154,1.154,0,1,0,0,2.308H32.839a1.154,1.154,0,1,0,0-2.308Zm0,5.769a1.154,1.154,0,1,0,0,2.308H32.839a1.154,1.154,0,1,0,0-2.308ZM17.742,63A1.731,1.731,0,1,0,16,61.269,1.736,1.736,0,0,0,17.742,63Zm1.742-7.5a1.742,1.742,0,1,0-1.742,1.731A1.736,1.736,0,0,0,19.484,55.5Z",
    transform: "translate(1418 -30.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerBulletins);
export default __webpack_public_path__ + "static/media/dealer_bulletins.d6c433ee9e448f22ea3b1858fd9d4e72.svg";
export { ForwardRef as ReactComponent };